'use strict';

var React = require('react');

var SvgPasskeyFilledMinor = function SvgPasskeyFilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16.5h-8.415a1.05 1.05 0 0 1-.855-1.662l.561-.786a6.094 6.094 0 0 1 7.459-2.016v.864c0 .9.506 1.683 1.25 2.077v1.523Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.125 9a2.625 2.625 0 0 0-2.625 2.625v1.275a1.35 1.35 0 0 0 1.25 1.346v2.605a1 1 0 0 0 .163.548l.422.644a1 1 0 0 0 1.495.206l.552-.482a1 1 0 0 0-.026-1.53l-.119-.096a.936.936 0 0 0 .276-1.414l-.331-.405v-.072h.218a1.35 1.35 0 0 0 1.35-1.35v-1.275a2.625 2.625 0 0 0-2.625-2.625Zm.875 2.625a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0Z"
  }));
};
SvgPasskeyFilledMinor.displayName = "PasskeyFilledMinor";

exports.SvgPasskeyFilledMinor = SvgPasskeyFilledMinor;
